import pick from 'lodash/pick'

import {ApiRequestStates} from '../const'
import {reducer} from './helpers'
import {
  GET_PARTICIPANT_INFO_SUCCESS,
  GET_USER_SUCCESS,
  LOGIN_SUCCESS,
  REGISTRATION_SUCCESS,
} from '../actions/api'
import {
  GET_ACCOUNT_BALANCE,
  GET_ACCOUNT_BALANCE_FAILURE,
  GET_ACCOUNT_BALANCE_PENDING,
  GET_ACCOUNT_BALANCE_SUCCESS,
  UPDATE_NAME,
  UPDATE_USER_INFO_SUCCESS,
  USER_AND_EVENT_PENDING,
  USER_AND_EVENT_RECEIVED,
  USER_AND_EVENT_NOT_RECEIVED,
} from '../actions/user'

export const initialState = {
  accountBalance: 0,
  fetchAccountBalanceStatus: ApiRequestStates.IDLE,
  itemizedAccountBalances: [],
  isUserAndEventPending: true,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case GET_ACCOUNT_BALANCE:
      return {
        accountBalance: initialState.accountBalance,
        itemizedAccountBalances: initialState.itemizedAccountBalances,
      }
    case GET_ACCOUNT_BALANCE_FAILURE:
      return {fetchAccountBalanceStatus: ApiRequestStates.ERROR}
    case GET_ACCOUNT_BALANCE_PENDING:
      return {fetchAccountBalanceStatus: ApiRequestStates.PENDING}
    case GET_ACCOUNT_BALANCE_SUCCESS:
      return {
        accountBalance: payload.accountBalance,
        fetchAccountBalanceStatus: ApiRequestStates.SUCCESS,
        itemizedAccountBalances: payload.itemizedAccountBalances,
      }
    case GET_PARTICIPANT_INFO_SUCCESS:
      return {email: payload.email}
    // store the user id off login and registration so we can immediately
    //  determine whether the user is a participant or not
    case LOGIN_SUCCESS:
    case REGISTRATION_SUCCESS:
      return pick(payload, [
        'email', // because if we have a user id, the UI will expect an email; see zendesk.js:identify()
        'firstName', // not 100% necessary, but helps more than it hurts; see email comment
        'id', // to confirm if the user is a participant
        'lastName', // not 100% necessary, but helps more than it hurts; see email comment
      ])
    case USER_AND_EVENT_PENDING:
      return {isUserAndEventPending: true}
    case USER_AND_EVENT_RECEIVED:
    case USER_AND_EVENT_NOT_RECEIVED:
      return {isUserAndEventPending: false}
    case GET_USER_SUCCESS:
      return payload
    case UPDATE_NAME:
      return {
        firstName: payload.firstName,
        lastName: payload.lastName,
      }
    case UPDATE_USER_INFO_SUCCESS:
      return payload
    default:
      return null
  }
})
